
import { Component, HostListener, OnInit, ViewChild, OnDestroy, Inject, PLATFORM_ID, Renderer2, ChangeDetectorRef, ElementRef } from '@angular/core';
import { WishlistService } from 'src/app/shared/services/wishlist.service';
import { Subscription } from 'rxjs/internal/Subscription';
import { ApiService } from 'src/app/shared/services/apiService.service';
import { ActivatedRoute, Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../../environments/environment';
import { CommonService } from 'src/app/shared/services/common.service';
import { BehaviourSubjectService } from 'src/app/shared/services/behaviour-subject.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { RootService } from 'src/app/shared/services/root.service';
import { SkeletonService } from 'src/app/shared/services/skeleton.service';
import { secureStorage } from 'src/app/shared/services/encryption/secureservice';
import { Options } from "@angular-slider/ngx-slider";
import { isPlatformBrowser } from '@angular/common';
import { ClevertapService } from 'src/app/shared/services/clevertap/clevertap.service';
import { CanonicalService } from '../../shared/seo/canonical.service';
import { BreadcrumbComponent } from '../../shared/components/breadcrumb/breadcrumb.component';
import { SeoService } from 'src/app/shared/seo/seo.service';
import { debounce } from 'lodash';
import { debounceTime, retry, timeout } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { from } from 'rxjs';
import { response } from 'express';
import { dismissModal } from 'src/app/configurator-app/conf-store/action';
declare var $;
@Component({
  selector: 'app-product-list',
  templateUrl: './product-list.component.html',
  styleUrls: ['product-list.component.scss']
})
export class ProductListComponent implements OnInit, OnDestroy {
  @ViewChild(BreadcrumbComponent) breadCrumb: BreadcrumbComponent;
  @ViewChild('cardElement') cardElementRef!: ElementRef;
 
  unbxFilter: any = false;
  explore: any;
  modifiedExploreData: any = [];
  maxValue: number = 3970880;
  selectedTerrain: string = '';

  ssoptions: Options = {
    floor: 2000000,
    ceil: 4000000,
    enforceStep: false,
    enforceRange: false,
  };

  environment1 = environment.s3bucket.url;
  productLoaded: boolean = false;
  heartUrls = {
    empty: '../../../assets/images/Star-unfilled.svg',
    half: '../../../assets/images/Star-unfilled.svg',
    full: '../../../assets/images/Star-filled.svg',
  };

  slideConfig = {
    infinite: true,
    speed: 100,
    slidesToShow: 1,
    slidesToScroll: 1,
    cssEase: 'linear',
    dots: true,
    autoplay: true,
    draggable: true,
    focusOnSelect: true,
    prevArrow: '.client-thumbnails .prev-arrow',
    nextArrow: '.client-thumbnails .next-arrow',
  };

  sub: Subscription = new Subscription();
  productList: any[] = [];
  actual_lob_name: any;
  lob_name: any;
  ppl_name: any;
  startValue: number = 0;
  endValue: number = 9;
  rowlimit: any;
  list: any;
  filterList: any = [];
  filterShowList: any = [];
  selected: any
  selectedFilter: any
  sortList = ["Select", "High To Low", "Low To High"]
  softFilterValue: any;
  sub_lob: any;
  model: any;
  public feedBackForm: FormGroup;
  isReviewSubmitted = false;
  sortingType: string = 'Select'
  breadcrumbData: any[] = []
  isWishlist: boolean = false;
  searchValue: any;
  isRating: boolean = false;
  ratingData: any = [];
  browsing: any;
  searching: any;
  design: any;
  recommend: any;
  isPopular: boolean = false
  columnFive:any;
  amcDataArray=[]
  data: any = {
    "hcv-cargo": [
      {
        "key": "Segment",
        "priority": "1",
        "isvisible": "1"
      },
      {
        "key": "Usage",
        "priority": "0",
        "isvisible": "1"
      },

      {
        "key": "Main Vehicle Category",
        "priority": "2",
        "isvisible": "1"
      },
      {
        "key": "Model",
        "priority": "3",
        "isvisible": "1"
      },
      {
        "key": "Budget",
        "priority": "4",
        "isvisible": "1"
      },
      {
        "key": "Tonnage (Gross Vehicle Weight) & Wheels",
        "priority": "5",
        "isvisible": "1"
      },
      {
        "key": "Fuel Type",
        "priority": "6",
        "isvisible": "1"
      },
      {
        "key": "Air Conditioning",
        "priority": "7",
        "isvisible": "1"
      },
      {
        "key": "Body",
        "priority": "8",
        "isvisible": "1"
      },
      {
        "key": "Load Body Length",
        "priority": "9",
        "isvisible": "1"
      },
      {
        "key": "Cabin Type",
        "priority": "10",
        "isvisible": "1"
      },
      {
        "key": "Wheels",
        "priority": "11",
        "isvisible": "1"
      }
    ],
    "global": [
      {
        "key": "Segment",
        "priority": "1",
        "isvisible": "1"
      },
      {
        "key": "Usage",
        "priority": "0",
        "isvisible": "1"
      },

      {
        "key": "Main Vehicle Category",
        "priority": "2",
        "isvisible": "1"
      },
      {
        "key": "Model",
        "priority": "3",
        "isvisible": "1"
      },
      {
        "key": "Budget",
        "priority": "4",
        "isvisible": "1"
      },
      {
        "key": "Tonnage (Gross Vehicle Weight) & Wheels",
        "priority": "5",
        "isvisible": "1"
      },
      {
        "key": "Fuel Type",
        "priority": "6",
        "isvisible": "1"
      },
      {
        "key": "Air Conditioning",
        "priority": "7",
        "isvisible": "1"
      },
      {
        "key": "Body",
        "priority": "8",
        "isvisible": "1"
      },
      {
        "key": "Load Body Length",
        "priority": "9",
        "isvisible": "1"
      },
      {
        "key": "Cabin Type",
        "priority": "10",
        "isvisible": "1"
      },
      {
        "key": "Wheels",
        "priority": "11",
        "isvisible": "1"
      }
    ]
  }
  vehicle_acpplication: any;
  actualLobName: any;
  ModelName: any;
  vehicleApplicationFilterArray: any = [];
  lobFilterArray: any = [];
  pplFilterArray: any = [];
  gvwFilterArray: any = [];
  modelFilterArray: any = [];
  airConditioningFilterArray: any = [];
  fuelTypeFilterArray: any = [];
  bodyTypeFilterArray: any = [];
  loadBodyFilterArray: any = [];
  cabinTypeFilterArray: any = [];
  wheelsFilterArray: any = [];
  price_From: any;
  price_To: any;
  breadcrumbdata: any = [];
  showBreadCrumb: boolean = false;
  breadcrumbList: {
    label: any; url: string;
    pageName: string;

  };
  form: FormGroup;
  isfilterListCalled: boolean = false
  unbxfilterclick: boolean = false;
  totolfiltervalues: number = 0
  priceRange: any = []
  userData: any;
  isUserLoggedIn: boolean;
  windowOffset: any = 2000;
  isFilterOpen: boolean = false;
  isBottomhide: boolean = true;
  isExplore: boolean = false;
  ExploreMappedData: any;
  ExploreMappedData1: any;
  cabinType: any;
  breadcrumblen: any = 0;
  onPageLoad = 0;
  metaTitle: any;
  metaDesc: any;
  exploreData: any;
  dealerLen: any = [];
  unbxSearchValue: string;
  pplValue:any
  isSearch:boolean=false
  disableSort:boolean=false
  isClear:boolean=false
  brand: any;
  searchExplore: any;
  expData1: any;
  expData: any;
  ExploreMappedDataType: any;
  explore_Lob: any;
  explore_ppl: any;
  explore_SubLob: any;
  ExploreMappedDatamodal: any;
  lob: any;
  typeOfBooking: string;
  annualRunningHours: any;
  amcDuration: any;
  isStartedAmc: boolean = false;
  isHCV: boolean = false;
  aplicationAmcData: any;
  annual_kms: any;
  kms: any[] = [];
  amc_duration: any;
  year: any[] = [];
  invalidReq = false;
  isAMC: boolean = false;
  terrainvalue: boolean = false;
  display: boolean = false;
  amcDurationOptions: Options = {
    floor: 12,
    ceil: 72,
    step: 12,
    showTicks: true,
  };
  annualRunningHoursOptions: Options = {
    floor: 1,
    ceil: 5,
    step: 1,
    showTicks: true,
  };
  currentStep: number = 1;
  terrainData: any;
  bookingData: any;
  annualRunningHoursChange$ = new Subject<number>();
  amcDurationChange$ = new Subject<number>();
  routeExplore: string;
  ValuePl: string;
  amcproductData: any;
  datadismiss: boolean = false;
  terraindaata: boolean = false;
  vehicleTypes = [
    "Municipal – Recovery truck",
    "Bulk Mix",
    "Cement Spreader",
    "Vacuum Truck",
    "Recycler",
    "Airport Refueller",
    "Water Pumps",
    "Fire Fighter",
    "Emergency Response",
    "Recovery Trucks",
    "Concrete Bulker",
    "Skip/Hook Loader",
    "Garbage Compactor",
    "Road Sweeper",
    "Telescopic Ladders",
    "Terminal Vehicles",
    "Concrete Pumps",
    "Truck Mounted Cranes",
    "Suction Cum Jetting Pump",
    "Puller – ODC",
    "Train - Tractor",
    "Diesel Bowser",
    "Well Drill Rigs",
    "Boom Pump",
    "Crane - Truck Mounted",
    "Recovery Vehicles",
    "Sewage Suction cum jetting",
    "Dumper Placer",
    "Mobile Service Van",
    "Cash Van",
    "Mobile ATM Van",
    "Hopper Tipper",
    "Bullion Vans",
    "Cable Testing Vans",
    "Troop Carrier",
    "Riot Control",
    "Towing Vans",
];
  prodata: { lob: any; };
  NewLob: any;
  osp_configurator_request:any;
osp_configurator_response:any;
vas_configurator_request:any;
vas_configurator_response:any;
  isChatbotLoaded: boolean = false;
    chatbotLoaded = false;
  constructor(private apiService: ApiService, private activatedRoute: ActivatedRoute,
    private seoservice: SeoService,
    public skeletonService: SkeletonService, private spinner: NgxSpinnerService,
    private toastrService: ToastrService, private CommonService: CommonService,
    private wishlistService: WishlistService, private behaviourSubject: BehaviourSubjectService,
    private fb: FormBuilder, private rootService: RootService,
    private router: Router, private localStorage: secureStorage,
    private cleverService: ClevertapService, @Inject(PLATFORM_ID) private platformId: Object,
    private cdRef: ChangeDetectorRef,
    private behaviorService: BehaviourSubjectService, private canonicalservice: CanonicalService,private renderer: Renderer2

  ) {
    this.onScroll = debounce(this.onScroll, 300);
    this.feedBackForm = this.fb.group({
      Browsing: [null, Validators.required],
      searching: [null, Validators.required],
      design: [null, Validators.required],
      recommend: [null, Validators.required],
      improvement: [null, Validators.required],
    });
    this.annualRunningHoursChange$.pipe(debounceTime(300)).subscribe((value) => {
      this.annualRunningHours = value;
      this.checkDataAvail();
      this.BookingVas();

    });

    this.amcDurationChange$.pipe(debounceTime(300)).subscribe((value) => {
      this.amcDuration = value;
      this.checkDataAvail();
      this.BookingVas();
    });
  }

  @HostListener('window:scroll', ['$event'])

  onScroll() {
    let totalNoOfRecords
    if (isPlatformBrowser(this.platformId)) {
      const scrollPosition = window.scrollY + window.innerHeight;
      const totalHeight = document.documentElement.scrollHeight;
  
      if (scrollPosition >= totalHeight / 2 && !this.chatbotLoaded) {
        console.log("User scrolled halfway, loading chatbot...");
        this.loadScript();
        this.chatbotLoaded = true;
      }
      if (window.innerHeight + window.scrollY + 500 >= document.body.offsetHeight && !this.showLoader) {
        if ((this.startValue + 9) < this.rowlimit) {
          this.startValue = this.startValue + 9
          this.endValue = this.endValue + 9
          totalNoOfRecords = localStorage.getItem('totalNoOfRecords')
          if (totalNoOfRecords != null && totalNoOfRecords != '' && totalNoOfRecords != undefined) {
            //this.endValue <= totalNoOfRecords &&  && this.endValue >= totalNoOfRecords
            if (this.endValue <= totalNoOfRecords && this.productList?.length <= totalNoOfRecords) {
              localStorage.removeItem('uniqueId');
              if (this.productList?.length > 1) {

                this.onUnbxResultScroll(this.startValue, 9)
              }
            }
            else
              return
          }
          else
            this.checkExploreData(this.startValue, this.endValue)
        }
      }
    }
  }


  ngOnInit(): void {
    if(isPlatformBrowser(this.platformId)){
    localStorage.removeItem('tat_id');
    this.behaviorService.isSmart.next(false);

      localStorage.setItem('catIdid','false')
    }
    this.activatedRoute.params.subscribe(params => {
      this.searchExplore = params['search'];
      this.behaviourSubject.RoutefromBrand.subscribe(res =>{
        if(res && res == 'brandpage'){
          this.behaviourSubject.BrandSCVsubje.subscribe(responsedata =>{
          //  localStorage.setItem('ValuePl', responsedata.level4_pl)
        this.ValuePl = responsedata.level4_pl
          })
          this.pplValue = params['lob']
          this.brand = params['brand']

        }else{
          this.pplValue = null
          this.brand=null
          // localStorage.removeItem("ValuePl")
        }
      })
    });
    this.canonicalservice.createCanonicalURL('');
    this.filterShowList = [];
    if (isPlatformBrowser(this.platformId)) {
      localStorage.removeItem('VASData')
      this.unbxFilter = this.localStorage.getItem("sideFilter") ? true : false
      this.behaviorService.searchval.subscribe((res)=>{
        this.unbxFilter = this.localStorage.getItem("sideFilter") ? true : false
        // this.unbxSearchValue=res
        this.unbxSearchValue=localStorage.getItem('searchValue')
        if (localStorage.getItem('searchValue')) {
        this.disableSort=true
        }
      })
      this.behaviorService.isClearfilter.subscribe((res)=>{

        if (res) {
        this.onUnbxfilterclick(0, 9)
        }
      })
      this.behaviorService.isSearch.subscribe((res)=>{
        this.isSearch=res
        let totalNoOfRecords = localStorage.getItem('totalNoOfRecords')
      if (this.isSearch) {
        if (Number(totalNoOfRecords)== 0 || totalNoOfRecords == null) {
          this.productList=[]
          this.productLoaded=true
          this.rowlimit=0

          return;
        }
      }
      })
      // this.unbxSearchValue=localStorage.getItem("searchValue")

      $('.header').addClass('p-scroll');

      try {
        this.cleverService.onPageView("Product List");
      } catch { }
    }
    this.sub.add(this.behaviorService.isLoggedIn.subscribe(() => {
      this.isUserLoggedIn = this.rootService.isLoggedIn() ? true : false;
      this.userData = this.rootService.getUserData();
    }));
    this.vehicle_acpplication = '';
    this.productList = [];
    this.CommonService.productsList = [];
    this.actualLobName = [];
    this.ModelName = [];
    this.lob_name = [];
    this.ppl_name = [];
    this.sub.add(this.activatedRoute.queryParams
      .subscribe(async (params: any) => {
        if (params?.cabintype) {
          this.cabinType = params.cabintype;
        }
        if (params?.dealer) {
          if (isPlatformBrowser(this.platformId)) {
            localStorage.setItem("dealercd", params['dealer']);
            this.getDealer()
          }
        }
        if (params) {
          this.vehicle_acpplication = params?.vehicle_application == 'E-Commerce   Light Goods' ? 'E-Commerce / Light Goods' : params?.vehicle_application;
          var filterValueTemp = [];
          if (params?.vehicle_application) {
            filterValueTemp.push({ event: this.vehicle_acpplication, category: "Usage" })
          }
          if (Array.isArray(params?.actual_lob_name)) {
            this.actualLobName = params?.actual_lob_name
          } else {
            if (params?.actual_lob_name) {
              this.actualLobName.push(params?.actual_lob_name)
            }
          }

          if (params?.actual_lob_name && params?.actual_lob_name != '' && params?.actual_lob_name != null) {
            filterValueTemp.push({ event: this.actualLobName[0], category: "Segment" })
          }
          if (Array.isArray(params?.model)) {
            this.ModelName = params?.model
          } else {
            if (params?.model) {
              this.ModelName.push(params?.model)
            }
          }
          if (params?.model && params?.model != '' && params?.model != null) {
            filterValueTemp.push({ event: this.ModelName[0], category: "Model" })
          }
          if (filterValueTemp?.length > 0) {
            if (isPlatformBrowser(this.platformId)) {

              localStorage.setItem("normalFilterValue", JSON.stringify(filterValueTemp))
            }
          }
          this.behaviourSubject.callPlp.subscribe(value => {
            if (value == true)
              this.getVehicleData(0, 9)
          })


          this.isPopular = params?.is_new_launch
          // this.ppl_name = [params.get('ppl_name')];
          if (params?.ppl) {
            let ppl = params?.ppl.split('&')
            for (var i = 0; i < ppl?.length; i++) {
              ppl[i] = ppl[i].replace(/AND/g, "&");
            }
            this.ppl_name = ppl
            if (isPlatformBrowser(this.platformId)) {

              let ismobile = localStorage.getItem('isMobileBannerSearch') ? localStorage.getItem('isMobileBannerSearch') : 'false';
              if (ismobile == 'true' && this.onPageLoad == 1) {
                if (isPlatformBrowser(this.platformId)) {

                  localStorage.setItem('isMobileBannerSearch', 'false');
                }
              }

              this.getFilterList();
            }
          }
        }
        if (isPlatformBrowser(this.platformId)) {
          localStorage.removeItem("myObject")
          let myObject = {
            "source": await params['utm_source'],
            "medium": await params['utm_medium'],
            "campaign": await params['utm_campaign'] || params['utm_campaignname'],
            "campaign_id": await params['gclid'],
          }
          this.localStorage.setItem("myObject", JSON.stringify(myObject));
        }
      }
      ));

    this.sub.add(this.activatedRoute.paramMap.subscribe(params => {

      let vanType = (params.get('lob_name'))?.toLowerCase();
      if (params.get('lob_name')) {
        this.actual_lob_name = params.get('lob_name');
      }
      if (this.actual_lob_name == 'buses-vans') {
        this.actual_lob_name = 'buses'
      }
      if (this.actual_lob_name == 'trucks') {
        this.actual_lob_name = 'icv-trucks'
      }
      this.lob_name = params.get('sub_lob');
      if (params.get('ppl_name')) {
        this.ppl_name = []
        this.ppl_name.push(params.get('ppl_name'));
      }
      this.searchValue = params.get('search');
      this.columnFive = params.get('columnFive');
      if (vanType === "trucks") {
        this.actual_lob_name = (this.lob_name.replace(/\s+/g, '-'))?.toLowerCase()
        this.lob_name = environment.truckLobId
      }
      if (vanType === "buses-vans") {
        this.actual_lob_name = (this.lob_name.replace(/\s+/g, '-'))?.toLowerCase()
        this.lob_name = environment.busLobId
      }
      if (vanType === "scv-pickups") {
        this.actual_lob_name = (this.lob_name.replace(/\s+/g, '-'))?.toLowerCase()
        this.lob_name = environment.SCVPickupsLobId
      }

      this.breadcrumbData = [params.get('lob_name'), params.get('sub_lob'), params.get('ppl_name')]
      this.getFilterList();
    }));
    this.sub.add(this.behaviourSubject.isMobileFilter.subscribe(isClosed => {
      if (isClosed == 'Close') {
        this.isFilterOpen = false;
        this.isBottomhide = true
      }
    }))
    this.sub.add(this.behaviourSubject.isFilterChange.subscribe(params => {
      if (isPlatformBrowser(this.platformId)) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
        if (this.unbxFilter) {
          this.onUnbxfilterclick(0, 9)
            this.onPageLoad = 1;
            this.isfilterListCalled = true
            if (this.unbxFilter) {
              this.filterList = localStorage.getItem("unbxFilterValue") ? JSON.parse(localStorage.getItem("unbxFilterValue")) : [];
              this.filterShowList = localStorage.getItem("unbxFilterValue") ? JSON.parse(localStorage.getItem("unbxFilterValue")) : [];

            }
            else{
              this.filterList = localStorage.getItem("normalFilterValue") ? JSON.parse(localStorage.getItem("normalFilterValue")) : [];
              this.filterShowList = localStorage.getItem("normalFilterValue") ? JSON.parse(localStorage.getItem("normalFilterValue")) : [];
            }
            if (this.filterShowList) {
              if (this.filterShowList.find(element => element.category == "price_from") && this.filterList.find(element => element.category == "price_to")) {
                var priceFrom = this.filterShowList.find(element => element.category == "price_from")
                var priceTo = this.filterShowList.find(element => element.category == "price_to")
                var json = {
                  "category": 'Budget',
                  "event": '₹' + priceFrom.event + '-' + '₹' + priceTo.event
                }
                let i = this.filterShowList.findIndex(element => element.category == 'price_from')
                this.filterShowList.splice(i, 1);
                let t = this.filterShowList.findIndex(element => element.category == 'price_to')
                this.filterShowList.splice(t, 1);
                this.filterShowList.push(json)
              }
            }
        }
      }
    }))
    this.sub.add(this.behaviourSubject.filterValue.subscribe(params => {

      if (params == this.vehicle_acpplication) {
        this.vehicle_acpplication = '';
      }
      if (params == this.actualLobName) {
        this.actualLobName = [];
      }
      if (params == this.ModelName) {
        this.ModelName = [];
      }
      if (params != true && params != false) {
        for (let j = 0; j < this.data[this.filterList]?.length; j++) {
          for (let i = 0; i < this.data[this.filterList][j]?.data?.length; i++) {
            if (params == this.data[this.filterList][j].data[i].key) {
              this.data[this.filterList][j].data[i].checked = false;
            }
          }
        }
        setTimeout(() => {
          this.isExplore = false;
          if (params == 'Explore') {
            this.isExplore = true;
          }
          if (params != 'Header') {
            this.getFilterList();
            if (this.isClear) {
              this.onUnbxfilterclick(0, 9)
            }
          }
          else {
            if (isPlatformBrowser(this.platformId)) {

              localStorage.removeItem('normalFilterValue');
            }
          }
        }, 100);
      }
    }))
    if (isPlatformBrowser(this.platformId)) {

      window.scrollTo(0, 0)
      this.ExploreMappedDatamodal = this.localStorage.getItem("ExploreMappedDatamodal") ?
      JSON.parse(this.localStorage.getItem("ExploreMappedDatamodal")) : null
      this.expData1 = this.ExploreMappedDatamodal
    }
    // this.getVehicleData(0, 9)
    // }

    this.form = this.fb.group({
      model: [
        { value: '', disabled: !this.typeOfBooking },
        [Validators.required, Validators.maxLength(45)],
      ],
      vehicles: ['1',
        [Validators.required, Validators.max(99), Validators.min(1)],
      ],
      application: ['', Validators.required],
      terrain: ['', Validators.required],
      range1: [
        this.annualRunningHours ? this.annualRunningHours.toString() : '',
        Validators.required,
      ],
      range2: [
        this.amcDuration ? this.amcDuration.toString() : '',
        Validators.required,
      ],
    });
  }

  showLoader: any = false;
  async checkExploreData(start: any, end: any) {
    if (isPlatformBrowser(this.platformId)) {
      this.ExploreMappedData = this.localStorage.getItem("ExploreMappedData") ?
        JSON.parse(this.localStorage.getItem("ExploreMappedData")) : null
      this.ExploreMappedData1 = this.localStorage.getItem("ExploreMappedData1") ?
        JSON.parse(this.localStorage.getItem("ExploreMappedData1"))[0] : null
      try {
        let data1: any
        if (this.localStorage.getItem("exploreData")) {
          this.exploreData = JSON.parse(this.localStorage.getItem("exploreData"))
          data1 = this.exploreData
          if (this.ExploreMappedData1)
            this.modifiedExploreData.push(this.ExploreMappedData1)
          if (this.ExploreMappedData) {
            if (this.ExploreMappedData?.categoryType == 'Type') {
              for (let i = 0; i < data1.browse_by_title?.length; i++) {
                if ((data1.browse_by_title[i]["icon"] == this.ExploreMappedData.icon) &&
                  (data1.browse_by_title[i].browse_by_type_title == this.ExploreMappedData.browse_by_type_title)) {
                  this.modifiedExploreData.push(data1.browse_by_title[i])
                }
              }
            }
            if (this.ExploreMappedData?.categoryType == 'Brand') {
              for (let i = 0; i < data1.explore_by_title?.length; i++) {
                if ((data1.explore_by_title[i]["icon"] == this.ExploreMappedData.icon) &&
                  (data1.explore_by_title[i].explore_by_type_title == this.ExploreMappedData.explore_by_type_title)) {
                  this.modifiedExploreData.push(data1.explore_by_title[i])
                }
              }
            }
          }

          // if (!this.unbxfilterclick) {

          this.getVehicleData(start, end)
          // }
        }
        if (!this.localStorage.getItem("exploreData")) {
          let urlValue = JSON.parse(this.localStorage.getItem("UrlData"))
          if (urlValue) {
            let data = {
              "vehicle_type": urlValue[1] ? (urlValue[1]).replace("-", " ") : '',
              "lob": urlValue[0] ? (urlValue[0]).replace("-", " ") : ''
            }
            this.apiService.getVehicleExploreData(data).subscribe({
              next: (response: any) => {
                if (response.success) {
                  data1 = response.data
                  this.localStorage.setItem("exploreData", JSON.stringify(data1))
                  if (this.ExploreMappedData1) {
                    data1.forEach(e => {
                      let iconName = e["icon"]
                      if (iconName == this.ExploreMappedData1.icon && e.ppl === this.ExploreMappedData1.ppl) {
                        this.modifiedExploreData.push(e)
                      }
                      this.getVehicleData(start, end)
                    })
                  }
                  if (this.ExploreMappedData) {
                    for (let i = 0; i < data1?.length; i++) {
                      if (this.ExploreMappedData?.categoryType == 'Type') {
                        if ((data1[i]["icon"] == this.ExploreMappedData.icon) &&
                          (data1[i].browse_by_type_title == this.ExploreMappedData.browse_by_type_title)) {
                          this.modifiedExploreData.push(data1[i])
                        }
                      } else if (this.ExploreMappedData?.categoryType == 'Brand') {
                        if ((i["icon"] == this.ExploreMappedData.icon) &&
                          (data1[i].explore_by_type_title == this.ExploreMappedData.explore_by_type_title)) {
                          this.modifiedExploreData.push(data1[i])
                        }
                      } else { }
                    }
                    this.getVehicleData(start, end)

                  }
                  if( this.ExploreMappedData1){
                    this.getVehicleData(start, end)
                  }

                }
              }
            })
          }
          else
            this.getVehicleData(start, end)


        }
      } catch (error) {
      }
    }
  }
  notAllowSpace(event: any) {
    if (event.target.selectionStart === 0 && event.which === 32) {
      event.preventDefault();
    }
  }

  onUnbxResultScroll(startValue: any, endValue: any) {
    if (isPlatformBrowser(this.platformId)) {
      let searchValue
      searchValue = localStorage.getItem('searchValue')
      this.sub.add(this.apiService.getUnbxdData(searchValue, startValue, endValue, '', '').subscribe({
        next: (res: any) => {
          let response = res.response.products
          let data = [], uniqueId = []
          if (response?.length > 0) {
            for (let i = 0; i < response?.length; i++) {
              data = (response[i].uniqueId);
              uniqueId.push(data)
            }
            localStorage.setItem('uniqueId', JSON.stringify(uniqueId))
            // if (9 <= this.productList?.length) {
              this.getVehicleData(startValue, response?.length)
            // }
          }
        },
        error(err) {

        },
        complete() {

        }
      }))
    }
  }

  getVehicleData(start, end) {
    let totalNoOfRecords
    let vcCollection: any = [];
    let uniqueId
    if (isPlatformBrowser(this.platformId)) {
      if (start == 0) {
        this.productList = [];
      }
      this.ExploreMappedData = this.localStorage.getItem("ExploreMappedData") ?
        JSON.parse(this.localStorage.getItem("ExploreMappedData")) : null;
        this.ExploreMappedDataType = this.localStorage.getItem("ExploreMappedDatatype") ?
        JSON.parse(this.localStorage.getItem("ExploreMappedDatatype")) : null;

        this.expData = this.ExploreMappedData
      this.ExploreMappedData1 = this.localStorage.getItem("ExploreMappedData1") ?
        JSON.parse(this.localStorage.getItem("ExploreMappedData1"))[0] : null

        this.ExploreMappedDatamodal = this.localStorage.getItem("ExploreMappedDatamodal") ?
        JSON.parse(this.localStorage.getItem("ExploreMappedDatamodal")) : null
       this.expData1 = this.ExploreMappedDatamodal

      if (this.ExploreMappedData1 || this.ExploreMappedData) {
        this.modifiedExploreData.forEach(element => {
          let dataCollection: any = []
          dataCollection.push(Object.assign([], (element.vehicle_number)))
          vcCollection = dataCollection[0]
        });
      }

      uniqueId = JSON.parse(localStorage.getItem('uniqueId'))
      totalNoOfRecords = localStorage.getItem('totalNoOfRecords')
      if (this.isSearch) {
        if (Number(totalNoOfRecords)== 0 || totalNoOfRecords == null) {
          this.productList=[]
          this.productLoaded=true
          return;
        }
      }
    }
      this.routeExplore =  JSON.parse(this.localStorage.getItem("explore"))
      let columnVans = [];
       let plData = []

      if(this.routeExplore === "school-van"  &&  this.expData.ppl === "Magic" ){
        columnVans = ['School Van']
        plData = []
      }else if(this.routeExplore === "passenger-van"  &&  this.expData.ppl === "Magic"){
        columnVans = ['Non-School Van']
        plData = []
      }else if(this.routeExplore === "passenger-van"  &&  this.expData.ppl === "Winger"){
        columnVans = [];
        plData = ['Winger-Deluxe']
      }else if(this.routeExplore === "school-van"  &&  this.expData.ppl === "Winger" ){
        columnVans = [];
        plData = ['Winger-School']
      }
      else if(this.routeExplore === "ambulance"  &&  this.expData.ppl === "Winger"){
        columnVans = [];
        plData = ['Winger-Ambulance']
      }else if(this.brand === "INTRA" || this.brand === "YODHA" ||this.brand === "ACE" ){
        // this.ValuePl = localStorage.getItem('ValuePl')
        columnVans = [];
        plData = [this.ValuePl]
      }

      // else if(this.routeExplore === "school-van"  &&  this.expData.ppl === "Magic" && this.EModeldData != true){

      // }



      this.startValue = start;
      this.endValue = end;

      let data =
      {
        "start_row": totalNoOfRecords ? 0 : start,
        "end_row": totalNoOfRecords ? 9 : end,
        // "lob_name":  vcCollection?.length > 0 ? [] : this.lob_name ? [this.lob_name] : [],
        // "lob_name": vcCollection?.length > 0 ? [] : (Array.isArray(this.lob_name) && this.lob_name.length > 0 ? this.lob_name : []),
        "lob_name": vcCollection?.length > 0 ? [] : this.lob_name && this.lob_name?.length > 0 ? [this.lob_name] : [],
        "actual_lob_name":vcCollection?.length > 0 ? [] : this.actual_lob_name ? [this.actual_lob_name] : (this.lobFilterArray?.length > 0) ? this.lobFilterArray :  this.expData ? [this.expData.lob] : [],
        "ppl_name":  this.expData ? [this.expData.ppl] : this.expData1 ? [this.expData1.ppl] : this.pplValue ? [this.pplValue] : (vcCollection?.length > 0 ? [] : (this.pplFilterArray?.length > 0 ? this.pplFilterArray : this.ppl_name ? this.ppl_name : [])) ,
        "pl_name": plData ? plData : [],
        "sort_by": this.softFilterValue ? this.softFilterValue : '',
        "vehicle_application": this.vehicleApplicationFilterArray?.length !== 0 ? this.vehicleApplicationFilterArray : this.vehicle_acpplication ? [this.vehicle_acpplication] : [],
        // "vehicle_number": vcCollection?.length > 0 ? vcCollection : uniqueId,
        // : this.searchValue ? [this.searchValue]
        "vehicle_number":this.pplValue ? [] :( uniqueId !== null ? uniqueId : vcCollection?.length > 0 ? vcCollection : []),
        "model": this.modelFilterArray?.length > 0 ? this.modelFilterArray : this.ModelName,
        "body_type": this.bodyTypeFilterArray,
        "fuel_type": this.fuelTypeFilterArray,
        "price_from": this.price_From,
        "price_to": this.price_To,
        "payload": [],
        "emission_norms": [],
        "wheels": this.wheelsFilterArray,
        "air_conditioning": this.airConditioningFilterArray,
        "load_body_length": this.loadBodyFilterArray,
        "cabin_type": this.cabinTypeFilterArray,
        "kerb_weight": [],
        "vehicle_status": [],
        "is_active": "",
        "from_date": "",
        "to_date": "",
        "gvw": this.gvwFilterArray,
        "is_home_brand": "",
        "is_popular": "",
        "is_new_launch": this.isPopular,
        "search": (this.ExploreMappedData || this.pplValue) ? "" : this.searchValue,
        "action_type": uniqueId ? "unbox" : "",
        // "brand":(this.ExploreMappedDataType === "Brand" && this.expData?.explore_by_brand != null) ? [this.expData?.explore_by_brand] : this.brand ? [this.brand] : [],
        "brand":(this.ExploreMappedDataType === "Brand" && this.expData?.explore_by_brand?.toUpperCase() != null) ? [this.expData?.explore_by_brand?.toUpperCase()] : this.brand ? [this.brand] : [],
        "column_five":this.searchValue === 'magic' ? [this.columnFive] : columnVans?.length > 0 ? columnVans : [],
        // "explore_type":( this.ExploreMappedDataType === "Type" && this.expData?.browse_by_type != null) ? [this.expData?.browse_by_type] : []
        "explore_type":( this.ExploreMappedDataType === "Type" && this.expData?.browse_by_type.toUpperCase() != null) ? [this.expData?.browse_by_type.toUpperCase()] : []

      }

      try {
        this.spinner.show()
        this.showLoader = true;
        this.list = []
        this.priceRange = []
        this.sub.add(this.apiService.getVehicleInfo2(data).subscribe({
          next: (response: any) => {
            this.productLoaded = true;
            if (response["success"]) {
              // this.behaviorService.RoutefromBrand.next(null);
              this.productLoaded = true;
              if (this.productList?.length == 1) {
                this.productList = [...response.data]
              }
              else{
                this.productList = [...this.productList, ...response.data]
              }
              let records=0
              // if (localStorage.getItem('totalNoOfRecords') && this.totolfiltervalues != 0)
                records = +(localStorage.getItem('totalNoOfRecords'))
              this.rowlimit = records ? records : response.total_records;
              this.metaTitle = response.metadata.ppl_title;
              this.metaDesc = response.metadata.ppl_description;
              this.seo(data.lob_name);
              if (isPlatformBrowser(this.platformId)) {
                localStorage.setItem('rowLimit', this.rowlimit);
              }
              this.behaviourSubject.isMobileFilter.next('rowLimit');
              this.spinner.hide();
              this.showLoader = false;
              this.list = this.productList;
              this.breadcrumb();
              this.productLoaded = true;
              for (var i = 0; i < this.list?.length; i++) {
                this.list[i].imgData = []
                if (this.list[i].images?.length > 5) {
                  for (var j = 0; j < 5; j++) {
                    this.list[i].imgData.push(this.list[i].images[j])
                  }
                }
                else {
                  this.list[i].imgData = this.list[i].images
                }

                if (this.list[i].price_range != null) {
                  this.priceRange.push(this.list[i].price_range)
                }
              }
              var max = this.priceRange.reduce((a, b) => Math.max(a, b));
              var Json = {
                maxValue: max,
              }
              this.behaviourSubject.budgetFilter.next(Json)
              if (this.list[0]?.sub_lob == "Icv Trucks")
                this.sub_lob = "trucks"
              if (this.list[0]?.sub_lob == "Buses")
                this.sub_lob = "buses-vans"
              if (this.list[0]?.sub_lob == "SCV Pickups")
                this.sub_lob = "scv-pickups"
              this.model = (this.list[0]?.model.replace(/\s+/g, '-'))?.toLowerCase()
              this.onFilterChange(this.sortingType, 'tab')
              if (!this.rootService.getUserData()) {
                let wishList: any = [];
                wishList = this.wishlistService.getWishlist();
                if (wishList?.length > 0) {
                  wishList.forEach((el: any) => {
                    for (let i = 0; i < this.list?.length; i++) {
                      if (el == this.list[i].id) {
                        this.list[i].wishlist = true
                      }
                    }
                  })
                }
              }
              localStorage.removeItem('uniqueId')
            }
            else if (!response.success) {
              // if (this.isExplore) {
              //   this.router.navigate(['/home'])
              // }
              this.productLoaded = true;
              this.list = []
              this.productList = [];
                this.spinner.hide();
                this.showLoader = false;
              this.rowlimit = 0;
              if (isPlatformBrowser(this.platformId)) {
                localStorage.setItem('rowLimit', this.rowlimit);
              }
              this.behaviourSubject.isMobileFilter.next('rowLimit');
            }
          },
          error: () => {
            this.productLoaded = true;
            this.list = []
            this.productList = [];
            this.spinner.hide();
            this.showLoader = false;
          },
          complete: () => {
          }
        })
        );
      }
      catch (error) {
      }
  }
  getFilterList() {
    if (isPlatformBrowser(this.platformId)) {

      this.onPageLoad = 1;
      this.isfilterListCalled = true
      // this.filterList = localStorage.getItem("normalFilterValue") ? JSON.parse(localStorage.getItem("normalFilterValue")) : [];
      // this.filterShowList = localStorage.getItem("normalFilterValue") ? JSON.parse(localStorage.getItem("normalFilterValue")) : [];
      if (this.unbxFilter) {
        this.filterList = localStorage.getItem("unbxFilterValue") ? JSON.parse(localStorage.getItem("unbxFilterValue")) : [];
        this.filterShowList = localStorage.getItem("unbxFilterValue") ? JSON.parse(localStorage.getItem("unbxFilterValue")) : [];
      }
      else{
        this.filterList = localStorage.getItem("normalFilterValue") ? JSON.parse(localStorage.getItem("normalFilterValue")) : [];
        this.filterShowList = localStorage.getItem("normalFilterValue") ? JSON.parse(localStorage.getItem("normalFilterValue")) : [];
      }
      if (this.filterShowList) {
        if (this.filterShowList.find(element => element.category == "price_from") && this.filterList.find(element => element.category == "price_to")) {
          var priceFrom = this.filterShowList.find(element => element.category == "price_from")
          var priceTo = this.filterShowList.find(element => element.category == "price_to")
          var json = {
            "category": 'Budget',
            "event": '₹' + priceFrom.event + '-' + '₹' + priceTo.event
          }
          let i = this.filterShowList.findIndex(element => element.category == 'price_from')
          this.filterShowList.splice(i, 1);
          let t = this.filterShowList.findIndex(element => element.category == 'price_to')
          this.filterShowList.splice(t, 1);
          this.filterShowList.push(json)
        }
      }
    }
    if (!this.unbxFilter) {
      this.generateArray();
    }

  }

  clickToremoveFilter(event: any) {
    if (this.unbxFilter) {
    this.isClear=true
    }
    if (event.category != 'Budget') {
      this.behaviourSubject.filterValue.next(event.event);
    }
    else {
      this.behaviourSubject.filterValue.next(event.category);
    }
  }

  generateArray() {
    this.vehicleApplicationFilterArray = [];
    this.lobFilterArray = [];
    this.pplFilterArray = [];
    this.gvwFilterArray = [];
    this.modelFilterArray = [];
    this.airConditioningFilterArray = [];
    this.fuelTypeFilterArray = [];
    this.bodyTypeFilterArray = [];
    this.loadBodyFilterArray = [];
    this.cabinTypeFilterArray = [];
    this.wheelsFilterArray = [];
    this.price_From = ""
    this.price_To = ""
    for (let i = 0; i < this.filterList?.length; i++) {
      if (this.filterList[i].category == "Usage") {
        this.vehicleApplicationFilterArray.push(this.filterList[i].event)
      }
      else if (this.filterList[i].category == "Segment") {
        this.lobFilterArray.push(this.filterList[i].event)
      }
      else if (this.filterList[i].category == "Main Vehicle Category") {
        this.pplFilterArray.push(this.filterList[i].event)
      }
      else if (this.filterList[i].category == "Tonnage (Gross Vehicle Weight) & Wheels") {
        this.gvwFilterArray.push(this.filterList[i].event)
      }
      else if (this.filterList[i].category == "Model") {
        this.modelFilterArray.push(this.filterList[i].event)
      }
      else if (this.filterList[i].category == "Air Conditioning") {
        this.airConditioningFilterArray.push(this.filterList[i].event)
      }
      else if (this.filterList[i].category == "Fuel Type") {
        this.fuelTypeFilterArray.push(this.filterList[i].event)
      }
      else if (this.filterList[i].category == "Body") {
        this.bodyTypeFilterArray.push(this.filterList[i].event)
      }
      else if (this.filterList[i].category == "Load Body Length") {
        this.loadBodyFilterArray.push(this.filterList[i].event)
      }
      else if (this.filterList[i].category == "Cabin Type") {
        this.cabinTypeFilterArray.push(this.filterList[i].event)
      }
      else if (this.filterList[i].category == "Wheels") {
        this.wheelsFilterArray.push(this.filterList[i].event)
      }
      else if (this.filterList[i].category == "price_from") {
        this.price_From = this.filterList[i].event
      }
      else if (this.filterList[i].category == "price_to") {
        this.price_To = this.filterList[i].event
      }
    }
    this.checkExploreData(0, 9);
  }
  onFilterChange(event: any, source: any) {
    var type
    if (source == '') {
      type = event?.target?.value ? event?.target?.value : event
    }
    else {
      type = event
    }
    if (type == 'High To Low') {
      this.list = this.list.sort((a: any, b: any) => {
        return <any>new Date(b.price_range) - <any>new Date(a.price_range);
      });
    }
    else if (type == 'Low To High') {
      this.list = this.list.sort((a: any, b: any) => {
        return <any>new Date(a.price_range) - <any>new Date(b.price_range);
      });
    }
  }

  clickToAddWishlist(event: any) {
    if (this.userData) {
      let index: any
      for (let e = 0; e < this.list?.length; e++) {
        if (this.list[e].id == event) {
          index = this.list.findIndex((e: any) => e.id == event)
        }
      }
      if (this.list[index].id == event) {
        if (this.list[index].wishlist == false) {
          this.list[index].wishlist = true
          this.addToWishlist(event, 'add')
          return
        }
        if (this.list[index].wishlist == true) {
          this.list[index].wishlist = false
          this.addToWishlist(event, 'delete')
          return
        }
      }
    }
    else {
      this.list.forEach((e: any) => {
        if (e.id == event)
          e.wishlist = !e.wishlist
      })
      this.wishlistService.addItemToWishList(event)
      let wishList: any = [];
      wishList = this.wishlistService.getWishlist();
      wishList.forEach((el: any) => {
        for (let i = 0; i < this.list?.length; i++) {
          if (el == this.list[i].id) {
            this.list.wishlist = true
          }
          else {
            this.list.wishlist = false
          }
        }
      })
    }
  }

  addToWishlist(event: any, type: any) {
    let data;
    if (type == 'add') {
      data = {
        "product": [event],
        "action_type": "add"
      }
    }
    else {
      data = {
        "action_type": "delete",
        "product_list": [event],
      }
    }
    try {
      this.sub.add(this.apiService.addToWishlist(data).subscribe({
        next: (res: any) => {
          if (type == 'add') {
            this.toastrService.success(res.data.msg);
            this.list.forEach((e: any) => {
              if (e.id == event) {
                e.wishlist = true
                return
              }
            })
          } else {
            this.toastrService.warning(res.data.msg)

          }
        },
        error: () => { },
        complete: () => { }
      }))
    } catch (error) {
    }
  }

  getDealer() {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.removeItem("dealername")
      {
        let data = {
          "dealer_code": localStorage.getItem("dealercd"),
          "action_type": "dropdown"
        };
        this.sub.add(this.apiService.getDealerList(data).subscribe({
          next: (response: any) => {
            if (response["success"]) {
              this.dealerLen = response?.data;
              localStorage.setItem("dealername", (this.dealerLen[0].division_name + '_' + this.dealerLen[0].dealer_code))
              this.behaviorService.dealerName.next(true)

            }
          },
          error: (error) => {
            this.toastrService.warning(error.data.msg);
          },
          complete: () => {
          }
        })
        );

      }
    }
  }

  submitFeedback() {
    if (this.feedBackForm.invalid) {
      this.toastrService.warning('Please fill all the details.');
      return;
    }
    let formData = new FormData
    formData.append("action_type", "website");
    formData.append("rating_data", JSON.stringify([{ "type": "Browsing", "rating": this.feedBackForm.value.Browsing }, { "type": "searching", "rating": this.feedBackForm.value.searching }, { "type": "design", "rating": this.feedBackForm.value.design }, { "type": "recommend", "rating": this.feedBackForm.value.recommend }]));
    formData.append("description", this.feedBackForm.value.improvement);
    if (this.isRating == false) {
      try {
        this.sub.add(this.apiService.createReview(formData).subscribe({
          next: (res: any) => {
            if (res.success) {
              this.isReviewSubmitted = true;
            }
            else {
              this.toastrService.warning(res.data.msg)
            }
          },
          error: () => {
          },
          complete: () => { }
        }))
      } catch (error) {
      }

    }
    else {
      try {
        formData.append("rating_master_id", this.ratingData[0]?.rating_master[0]?.rating_master);
        this.sub.add(this.apiService.updateReview(formData).subscribe({
          next: (res: any) => {
            if (res.success) {
              this.isReviewSubmitted = true;
              this.toastrService.warning(res.data.msg)
            }
            else {
              this.toastrService.warning(res.data.msg)
            }
          },
          error: () => {
          },
          complete: () => { }
        }))
      } catch (error) {
      }

    }

  }

  getReview() {
    try {
      let data = {
        "action_type": 'website',
        "is_customer_rating": true
      }
      this.sub.add(this.apiService.getRatings(data).subscribe({
        next: (res: any) => {
          if (res.success) {
            this.ratingData = res?.data;
            if (this.ratingData?.length > 0) {
              this.isRating = true;
              if (isPlatformBrowser(this.platformId)) {

                var element = document.getElementById('feedbackBtn');
                element.click();
              }
              this.browsing = this.ratingData[0]?.rating_master.filter((item: any) => item.parameter == 'Browsing');
              this.searching = this.ratingData[0]?.rating_master.filter((item: any) => item.parameter == 'searching');
              this.design = this.ratingData[0]?.rating_master.filter((item: any) => item.parameter == 'design');
              this.recommend = this.ratingData[0]?.rating_master.filter((item: any) => item.parameter == 'recommend');

              this.feedBackForm.controls['Browsing'].setValue(this.browsing ? (this.browsing[0]?.rating).toString() : '');
              this.feedBackForm.controls['searching'].setValue(this.searching ? (this.searching[0]?.rating).toString() : '');
              this.feedBackForm.controls['design'].setValue(this.design ? (this.design[0]?.rating).toString() : '');
              this.feedBackForm.controls['recommend'].setValue(this.recommend ? (this.recommend[0]?.rating).toString() : '');
              this.feedBackForm.controls['improvement'].setValue(this.ratingData ? this.ratingData[0]?.description : '');
            } else {
              if (isPlatformBrowser(this.platformId)) {

                var element = document.getElementById('feedbackBtn');
                element.click();
              }
            }
          }
          else {
            this.isRating = false;
            this.toastrService.warning(res.data.msg)
          }
        }
      }))
    } catch (error) {
      this.toastrService.warning('Something went wrong.Please try after sometime.')
    }
  }

  breadcrumb() {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.removeItem('localBreadCrumb');
      if (this.searchValue) {
        this.breadcrumbdata = []
        this.breadcrumbList = {
          label: this.searchValue,
          url: ``,
          pageName: 'product-details',

        };
        this.breadcrumbdata.push(this.breadcrumbList);
      }
      else {
        this.breadcrumbdata = []
        this.breadcrumbList = {
          label: this.productList[0].sub_lob.replace(/\s/g, "-")?.toLowerCase() == 'icv-trucks' ? 'Trucks' : this.productList[0].sub_lob.replace(/\s/g, "-")?.toLowerCase() == 'buses' ? 'Buses & Vans' : this.productList[0].sub_lob,
          url: `/product-list/` + (this.productList[0].sub_lob.replace(/\s/g, "-")?.toLowerCase() == 'icv-trucks' ? 'trucks' : (this.productList[0].sub_lob.replace(/\s/g, "-")?.toLowerCase()) == 'buses' ? 'buses-vans' : this.productList[0].sub_lob.replace(/\s/g, "-")?.toLowerCase()),
          pageName: 'product-details',
        };

        this.breadcrumbdata.push(this.breadcrumbList);
        this.breadcrumbList = {
          label: this.productList[0].lob,
          url: `/category-list/` + (this.productList[0].sub_lob.replace(/\s/g, "-")?.toLowerCase() == 'icv-trucks' ? 'trucks' : (this.productList[0].sub_lob.replace(/\s/g, "-")?.toLowerCase()) == 'buses' ? 'buses-vans' : this.productList[0].sub_lob.replace(/\s/g, "-")?.toLowerCase()) + `/` + this.productList[0].lob?.replace(/\s/g, "-")?.toLowerCase(),
          pageName: 'product-details',
        };
        this.breadcrumbdata.push(this.breadcrumbList);
        if (!this.cabinType) {
          this.sub.add(this.activatedRoute.queryParams
            .subscribe((params: any) => {
              this.explore = params

              if (params.cabintype) {
              }
            }));
          this.breadcrumbList = {
            label: this.productList[0].ppl,
            url: `/category-list/` + (this.productList[0].sub_lob.replace(/\s/g, "-")?.toLowerCase() == 'icv-trucks' ? 'trucks' : (this.productList[0].sub_lob.replace(/\s/g, "-")?.toLowerCase()) == 'buses' ? 'buses-vans' : this.productList[0].sub_lob.replace(/\s/g, "-")?.toLowerCase()) + `/` + this.productList[0].lob?.replace(/\s/g, "-")?.toLowerCase() + `/` + this.productList[0].ppl?.replace(/\s/g, "-").replace("---", "-")?.toLowerCase(),
            pageName: 'category-list',
          };
          this.breadcrumbdata.push(this.breadcrumbList);
        }
      }
      if (this.cabinType) {

        this.breadcrumbList = {
          label: this.cabinType,
          url: ``,
          pageName: 'category-list',
        };
        this.breadcrumbdata.push(this.breadcrumbList);
      }
      if (isPlatformBrowser(this.platformId)) {

        this.localStorage.setItem(
          'localBreadCrumb',
          JSON.stringify(this.breadcrumbdata)
        );
      }
      this.breadCrumb?.getBreadCrumb()
      this.showBreadCrumb = true;

      this.breadcrumblen = this.breadcrumbdata?.length;
      this.seoservice.callSchema();
    }
  }

  redirect(sub_lob, lob, ppl, model, id) {
    let lobname = lob ? ((lob.replace(/\//g, "-").replace(/\s/g, "-"))?.toLowerCase()) : lob
    let pplname = ppl ? ((ppl.replace(/\//g, "-")).replace(/\s/g, "-").replace("---", "-"))?.toLowerCase() : ppl;
    let modelname = model ? ((model.replace(/\//g, "-")).replace(/\s/g, "-").replace("---", "-"))?.toLowerCase() : model;
    let sublob = sub_lob.replace(/\s/g, "-")?.toLowerCase() == 'icv-trucks' ? 'trucks' : sub_lob.replace(/\s/g, "-")?.toLowerCase() == 'buses' ? 'buses-vans' : sub_lob.replace(/\s/g, "-")?.toLowerCase()
    var currentUrl = '/product-details/' + sublob + '/' + lobname + '/' + pplname + '/' + modelname + '/' + id;
    return currentUrl;
  }

  exploreVehicle() {
    if(isPlatformBrowser(this.platformId)){
    localStorage.removeItem('sideFilter')
    localStorage.removeItem('totalNoOfRecords')
    localStorage.removeItem('uniqueId')
    localStorage.removeItem('searchValue')
    localStorage.removeItem('filterValue');
    localStorage.removeItem('unbxFilterValue');
    localStorage.removeItem('ExploreMappedDatatype');
    localStorage.removeItem('ExploreMappedData');

    }
    this.behaviorService.isUnbxFilterChange.next(false)
    this.behaviorService.isSearch.next(false)
    this.behaviorService.callPlp.next(false)
    this.behaviorService.isClearfilter.next(false);
    this.isExplore = true;
    this.searchValue = ''
    this.behaviourSubject.filterValue.next('Explore');
    this.router.navigate(['/product-list/']);
  }
  callConfigurator() {
    if (isPlatformBrowser(this.platformId)) {

      if (this.rootService.getUserData()) {
        localStorage.removeItem('VASData')
      }
      else {
        localStorage.setItem('previousUrl', '/configurator-home')
      }
    }
  }

  redirectLogin() {
    if (isPlatformBrowser(this.platformId)) {

      if (!this.isUserLoggedIn) {
        localStorage.setItem('previousUrl', this.router.url)
        this.router.navigate(['/login/']);
      }
    }
  }
 async bookNow(data,tat?) {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.removeItem("VASData");
      data=this.bookingData
      if( this.datadismiss == true){
        let vasSelectedData= {
          AnnualKms:  Math.floor(this.form.controls['range1'].value / 12),
          Exshowroomprice: this.bookingData?.price_range, // need to confirm
          LOB: this.bookingData?.lob,
          NoOfyears: Math.floor(this.form.controls['range2'].value.toString()/12),
          SubLob: this.bookingData?.sub_lob,
          VASBookingAmount: (this.bookingData.sub_lob =="scv-cargo" || this.bookingData.sub_lob =="pickups" || this.bookingData.sub_lob == "scv-pickups" || this.bookingData.sub_lob =="scvpass" || this.bookingData.sub_lob =="scpass") ? 1000 : 2000,
          // VASPLAN: this.amcproductData[0]?.amc_fms_plan?.plan,
          // VASTotalAmount: this.amcproductData[0]?.amc_fms_plan?.price_per_year, // need to confirm
          VASPLAN:this.amcDataArray,
          VASTotalAmount:this.calculateTotalAmountperyear(this.amcDataArray),
          VCNUMBER: this.bookingData?.vehicle_number,
          VasAvailable: "YES",
          crmApplication: '',
          fuel_type: this.bookingData?.fuel_type ? this.bookingData?.fuel_type :  "", // need to ask
          isViaConfigurator: true,
          isViaOSPVas:true,
          openPage: "booking",
          taggedVC: [],
          recommended_quantity:this.form.controls['vehicles'].value,
          terrian:  this.form.controls['terrain'].value,
          vasApplication:  this.form.controls['application'].value.actual_application,
          }
        this.localStorage.setItem('VASData',JSON.stringify(vasSelectedData));
      }
      if(tat == true) {
      try {
        await this.vastatrequestresponsereturn(); // Wait for API response
      } catch (error) {
        console.error("Error in vastatrequestresponse:", error);
      }
    }
      if (this.isUserLoggedIn) {
        let sublob = data.sub_lob.replace(/\s/g, "-")?.toLowerCase() == 'icv-trucks' ? 'trucks' : (data.sub_lob.replace(/\s/g, "-")?.toLowerCase()) == 'buses' ? 'buses-vans' : data.sub_lob.replace(/\s/g, "-")?.toLowerCase();
        let model = data.model.replace(/\s/g, '-').replace(/\//g, '-').replace(/\+/g, '-').replace(/\./g, '-')?.toLowerCase();
        this.router.navigate(['/lead-booking/' + sublob + '/' + data.lob_seo + '/' + data.ppl_seo + '/' + model + '/' + data.id]);
      }
      else {
        let sublob = data.sub_lob.replace(/\s/g, "-")?.toLowerCase() == 'icv-trucks' ? 'trucks' : (data.sub_lob.replace(/\s/g, "-")?.toLowerCase()) == 'buses' ? 'buses-vans' : data.sub_lob.replace(/\s/g, "-")?.toLowerCase();
        let model = data.model.replace(/\s/g, '-').replace(/\//g, '-').replace(/\+/g, '-').replace(/\./g, '-')?.toLowerCase();
        localStorage.setItem('previousUrl', '/lead-booking/' + sublob + '/' + data.lob_seo + '/' + data.ppl_seo + '/' + model + '/' + data.id)
        this.router.navigate(['/login/']);
      }
      this.clevertap(data);
    }
  }
  toggleFilters() {
    this.isFilterOpen = !this.isFilterOpen;
    this.isBottomhide = false
  }

  closeSort() {
    if (isPlatformBrowser(this.platformId)) {
      $('.sort-mobile-view').addClass('d-none');
    }
  }
  seo(categoryData) {
    let data = categoryData?.length == 1 ? categoryData[0] : '';

    let metaTitle = categoryData?.length == 1 ? "Buy " + data + " Online in India. Check Price, Features and View Details | Tata Motors OSP" : "Buy Tata Trucks and Buses Online in India - Tata Motors";
    let metaDesc = categoryData?.length == 1 ? "Enquire, Book and Buy " + data + " at buytrucknbus.tatamotors.com with Tata Motors authorized dealers" : "Enquire, book and buy online Tata Ace, Intra, Yodha Pickup, Winger, Magic, Signa, Prima, Ultra, and entire Truck, Tipper, Bus range with Tata Motors authorized dealers.";
    this.seoservice.updateTitle(metaTitle);
    this.seoservice.updateMetaTag("description", null, this.metaDesc ? this.metaDesc : metaDesc);
    this.seoservice.updateMetaTag(null, "og:locale", "en_US");
    this.seoservice.updateMetaTag(null, "og:type", "Website");
    this.seoservice.updateMetaTag(null, "og:title", this.metaTitle ? this.metaTitle : metaTitle);
    this.seoservice.updateMetaTag(null, "og:description", this.metaDesc ? this.metaDesc : metaDesc);
    this.seoservice.updateMetaTag(null, "og:site_name", "Tata OSP");
  }
  openSort() {
    if (isPlatformBrowser(this.platformId)) {
      $('.sort-mobile-view').addClass('d-block');
      $('.sort-mobile-view').removeClass('d-none');
    }
  }

  clevertap(productDetailsData: any) {
    if (isPlatformBrowser(this.platformId)) {
      try {
        this.cleverService.onBookNowButtonClick(productDetailsData["id"],
          productDetailsData["model"], productDetailsData['images'][0].image_url, "Top Navigation");
      }
      catch { }
    }

  }
  clevertapPDP(productDetailsData) {

    if (isPlatformBrowser(this.platformId)) {
      try {
        this.cleverService.
          onProductDetailsPageButtonClick("Product detail", productDetailsData["id"], productDetailsData["model"], productDetailsData['images'][0].image_url, "Top Navigation")
      }
      catch { }
    }
  }
  onUnbxfilterclick(startValue: any, endValue: any) {
    if (isPlatformBrowser(this.platformId)) {
      this.unbxfilterclick = true;
      let filterVal
      filterVal = localStorage.getItem('unbxFilterValue')
      const parsedData = JSON.parse(filterVal);
      const events = [];
      const categories = [];
      if (parsedData) {
        parsedData.forEach(item => {
          events.push(item.event);
          categories.push(item.category);
        });
      }
      this.totolfiltervalues = events?.length;
      let searchValue
      searchValue = localStorage.getItem('searchValue')
      this.sub.add(this.apiService.getUnbxdData(searchValue, startValue, endValue, categories, events).subscribe({
        next: (res: any) => {
          let response = res.response.products
          let data = [], uniqueId = []
          if (response?.length > 0) {
            for (let i = 0; i < response?.length; i++) {
              data = (response[i].uniqueId);
              uniqueId.push(data)
            }
            let totalNoOfRecords = res.response.numberOfProducts
            localStorage.setItem('totalNoOfRecords', totalNoOfRecords)
            localStorage.setItem('uniqueId', JSON.stringify(uniqueId))
            this.getVehicleData(startValue, response?.length)
          }
        },
        error(err) {

        },
        complete() {

        }
      }))
    }
  }


  goToamc(data): void {
    if (this.form.valid) {
      const formData = this.form.value;
      this.confirmData(data);
    }
  }

  previousStep() {
    if (this.currentStep > 1) {
      this.currentStep--;
    }
  }

  fetchAmcData(data: any) {
      this.isAMC = false;
      this.showLoader=true;
      if(isPlatformBrowser(this.platformId)){
      this.sub.add(
        this.apiService.getAMCData(data).subscribe({
          next: (response: any) => {
            if (response.STATUS == 'SUCCESS') {
              const amcData = response.RESPONSE.DATA;
              this.isAMC = amcData?.amc_type?.length > 0;
              if (this.isAMC) {
                const btn = document.getElementById('booking_amcbtn');
                if (btn) {
                  btn.click();
                  this.showLoader=false
                }
              }
              else{
                this.isAMC = false;
                this.bookNow(this.bookingData)
                this.showLoader=false
              }
            } else {
              this.isAMC = false;
              this.bookNow(this.bookingData)
              this.showLoader=false
            }
          },
          error: () => {
            this.isAMC = false;
            this.showLoader=false
          },
          complete: () => {
            this.showLoader=false
          },
        })
      );
    }

  }

  checkbook() {
    const excludedUrlPattern = '/booking-amc-list/';
    if(isPlatformBrowser(this.platformId)){
      if (this.isAMC) {
        const btn = document.getElementById('booking_amcbtn');
        if (btn) {
          btn.click();
        }
      }
    }
    
  }

  applicationAMC() {
    try {
      const specificPlValues = [
        'SIGNA 4830.TK.',
        'SIGNA 4830.TK. FBV',
        'SIGNA 4825.TK.',
        'SIGNA 4230.TK.'
      ];

      this.prodata = (this.bookingData.lob === 'HCV Const' && specificPlValues.includes(this.bookingData.pl))
        ? {lob: "HCV Cargo" }
        : { lob: this.bookingData?.lob };
      this.sub.add(
        this.apiService.amcAplicationData(this.prodata).subscribe({
          next: (response: any) => {
            // this.spinner.hide();
            if (response.success) {
              this.terraindaata = false;
              this.aplicationAmcData = response?.data?.vasrecappl_data;
              // this.terrainAMCData();
            } else {
              this.isAMC = false;
            }
          },
          error: () => {
            this.isAMC = false;
          },
          complete: () => {},
        })
      );
    } catch (error) {}
  }

  terrainAMCData(event: any) {
    const selectedValue = this.form.controls['application'].value?.display_application;
    this.terraindaata = false;
    if ((this.bookingData.lob === 'HCV Const' || this.bookingData.lob === 'HCV Cargo' || this.bookingData.lob === 'ICV Trucks' || this.bookingData.lob === 'LCV' || this.bookingData.lob === 'MCV Trucks' )&& this.vehicleTypes.includes(selectedValue)) {
      this.terraindaata = true;
      this.terrainvalue = true
      this.spinner.hide();
      return;
    }
    try {
      let data = {
        application:this.form.controls['application'].value.actual_application,
        output_type: 'terrain',
        vc_no: this.bookingData?.vehicle_number,
        pl: this.bookingData?.pl,
        lob_name: this.NewLob?.toLowerCase()
      };
      this.sub.add(
        this.apiService.getAMCData(data).subscribe({
          next: (response: any) => {
            // this.spinner.hide();
            if (response.STATUS == 'SUCCESS') {
              this.form.controls['terrain'].setValue('');
              this.terrainData = [];
              this.terrainData = response.RESPONSE.DATA.terrain;
              if (response.STATUS == 'SUCCESS' && this.terrainData?.length <= 0) {
                this.terrainvalue = true
              }else{
                this.terrainvalue = false
              }

              // this.sliderdata()
            } else {
              this.isAMC = false;
            }
          },
          error: () => {
            this.isAMC = false;
          },
          complete: () => {},
        })
      );
    } catch (error) {}
  }
  sliderdata() {
    try {
      let data = {
        output_type: 'all',
        vc_no: this.bookingData?.vehicle_number,
        terrain: this.form.controls['terrain'].value,
        application: this.form.controls['application'].value.actual_application,
        pl: this.bookingData?.pl,
        lob_name: this.NewLob?.toLowerCase()
      };

      this.sub.add(
        this.apiService.getAMCData(data).subscribe({
          next: (response: any) => {
            if (response.STATUS === 'SUCCESS') {

              this.annual_kms = response.RESPONSE.DATA.map(
                (element) => element.annual_kms
              );
              this.amc_duration = response.RESPONSE.DATA.map(
                (element) => element.amc_duration
              );

              this.kms = [...new Set(this.annual_kms)].sort(
                (a, b) => Number(a) - Number(b)
              );
              this.year = [...new Set(this.amc_duration)].sort(
                (a, b) => Number(a) - Number(b)
              );

              this.annualRunningHoursOptions = {
                floor: Math.min(...this.kms),
                ceil: Math.max(...this.kms),
                showTicksValues: true,
                translate: (value: number): string => {
                  return Math.round(value).toString();
                },
              };

              this.amcDurationOptions = {
                floor: Math.min(...this.year),
                ceil: Math.max(...this.year),
                showTicksValues: true,
                translate: (value: number): string => {
                  return value / 12 + '';
                },
              };

              this.annualRunningHours = this.kms[0];
              this.amcDuration = this.year[0];
              this.generateStepsArraykms();
              this.generateStepsArray();
              this.BookingVas();
              if (response.RESPONSE.DATA?.length > 0) {
                this.display = true
              }else{
                this.display = false
              }

            } else {
              this.isAMC = false;
            }
          },
          error: (error) => {
            this.isAMC = false;
            console.error('API Error:', error);
          },
          complete: () => {},
        })
      );
    } catch (error) {
      console.error('Sliderdata Error:', error);
    }
  }

 async confirmData(data1) {
    try {
      let data = {
        output_type: 'all',
        application: this.form.controls['application'].value.actual_application,
        terrain: this.form.controls['terrain'].value,
        vc_no: this.bookingData.vehicle_number,
        amc_duration: this.form.controls['range2'].value.toString(),
        annual_kms: this.form.controls['range1'].value.toString(),
        pl: this.bookingData?.pl,
        lob_name: this.NewLob?.toLowerCase()
      };
      this.sub.add(
        this.apiService.getAMCData(data).subscribe({
          next: async (response: any) => {
            // this.spinner.hide();
            if (response.STATUS == 'SUCCESS') {
              if (response?.RESPONSE?.DATA?.length > 0) {
                this.invalidReq = false;
                if(isPlatformBrowser(this.platformId)){

                  localStorage.removeItem('amcPlan');
                }
                let amcData = [];
                amcData = response.RESPONSE.DATA;
                if (data1 == true) {
                  try {
                    await this.vastatrequestresponse(); // Wait for API response
                  } catch (error) {
                    console.error("Error in vastatrequestresponse:", error);
                  }
                }
              
                // this.BookingVas()
                // this.translate();
                let sublob =
                  this.bookingData.sub_lob
                    .replace(/\s/g, '-')
                    ?.toLowerCase() == 'icv-trucks'
                    ? 'trucks'
                    : this.bookingData.sub_lob
                        .replace(/\s/g, '-')
                        ?.toLowerCase() == 'buses'
                    ? 'buses-vans'
                    : this.bookingData.sub_lob
                        .replace(/\s/g, '-')
                        ?.toLowerCase();
                let model = this.bookingData.model
                  .replace(/\s/g, '-')
                  .replace(/\//g, '-')
                  .replace(/\+/g, '-')
                  .replace(/\./g, '-')
                  ?.toLowerCase();
                let applicat = this.form.controls['application'].value?.actual_application?.replace(
                  /-/g,
                  '#'
                );
                let applicatin = applicat.replace(/\//g, '-');
                let terrain = this.form.controls['terrain'].value.replace(
                  /\//g,
                  '-'
                );
                this.router.navigate([
                  '/booking-amc-list/' +
                    sublob +
                    '/' +
                    this.bookingData.lob_seo +
                    '/' +
                    this.bookingData.ppl_seo +
                    '/' +
                    model +
                    '/' +
                    this.bookingData.id +
                    '/' +
                    this.bookingData.vehicle_number +
                    '/' +
                    applicatin +
                    '/' +
                    terrain +
                    '/' +
                    this.form.controls['range2'].value +
                    '/' +
                    this.form.controls['range1'].value,
                ]);
                if(isPlatformBrowser(this.platformId)){

                  localStorage.setItem('quantity', this.form.controls['vehicles'].value,)
                }
              } else{
                this.invalidReq = true;
              }
            } else {
              this.invalidReq = true;
            }
          },
        })
      );
    } catch (error) {}
  }
  checkDataAvail() {
    try {
      let data = {
        output_type: 'all',
        application: this.form.controls['application'].value.actual_application,
        terrain: this.form.controls['terrain'].value,
        vc_no: this.bookingData.vehicle_number,
        amc_duration: this.form.controls['range2'].value.toString(),
        annual_kms: this.form.controls['range1'].value.toString(),
        pl: this.bookingData?.pl,
        lob_name: this.NewLob?.toLowerCase()
      };
      this.osp_configurator_request = data;
      this.sub.add(
        this.apiService.getAMCData(data).subscribe({
          next: (response: any) => {
            this.osp_configurator_response = response;
            if (response.STATUS == 'SUCCESS') {
              if (response?.RESPONSE?.DATA?.length > 0) {
                this.invalidReq = false;
                this.BookingVas();
              } else{
                this.invalidReq = true;
              }
            } else {
              this.invalidReq = true;
            }
          },
        })
      );
    } catch (error) {}
  }

  generateStepsArray(): void {
    this.amcDurationOptions.stepsArray = this.year.map((value) => {
      return { value };
    });
    // this.BookingVas();
  }

  generateStepsArraykms(): void {
    this.annualRunningHoursOptions.stepsArray = this.kms.map((value) => {
      return { value };
    });
    // this.BookingVas();
  }

  onAnnualRunningHoursChange(event: number): void {
    this.annualRunningHours = event;
    this.annualRunningHoursChange$.next(event);
    // this.BookingVas();
    // this.checkDataAvail()
  }

  onAmcDurationChange(event: number): void {
    this.amcDuration = event;
    this.amcDurationChange$.next(event);


    // this.BookingVas();
    // this.checkDataAvail()
  }

  checkAmcData(value:any) {
    localStorage.removeItem('tat_id');
    localStorage.removeItem('schemeCode');
    this.bookingData=value
    try {
      if(value.vehicle_number){
        let lobValue = '';
        switch (value.lob) {
          case 'hcv-const':
          case 'hcv-cargo':
            case 'HCV Const':
              case 'HCV Cargo':
            lobValue = 'hcv';
            break;
          case 'bus':
            case 'BUSES':
              case 'Buses':
            lobValue = 'bus';
            break;
          case 'magic':
            lobValue = 'tata_magic';
            break;
          case 'winger':
            case 'SCPASS':
            lobValue = 'winger';
            break;
          case 'hcv':
            lobValue = 'hcv';
            break;
          case 'ilmcv':
            lobValue = 'ilmcv';
            break;
          case 'scv':
            case 'SCV CARGO':
            lobValue = 'scv';
            break;
          case 'ScPass':
            lobValue = 'winger';
            break;
          case 'SCVPass':
            lobValue = 'tata_magic';
            break;
          case 'SCV Cargo':
            lobValue = 'scv';
            break;
          case 'Pickups':
            case 'PICKUPS':
          case 'Yodha & Intra':
            lobValue = 'scv';
            break;
          case 'mcv-trucks':
          case 'icv':
          case 'mhcv':
            case 'MCV Trucks':
              case 'ICV Trucks':
              case 'LCV':
            lobValue = 'ilmcv';
            break;
          default:
            lobValue = value.lob; 
            break;
        }
        this.NewLob = lobValue;
        const data = {
          output_type: 'amc_type',
          vc_no: value?.vehicle_number,
          pl: this.bookingData?.pl,
        lob_name: this.NewLob?.toLowerCase()
      };
      this.fetchAmcData(data);
    }
    else{
      this.bookNow(value)
    }

    } catch (error) {
      console.error('Error in checkAmcData:', error);
    }
  }
  closeModal(){
    this.currentStep=1
    this.form.reset({
      application: '',
      terrain: '',
      vehicles: 1,
       model: this.bookingData.model,
       range1: '',
       range2: ''
   });
   this.selectedTerrain = '';
   this.terrainvalue = false
  // this.form.reset()
  }
  onTerrainChange(event: Event) {
    const target = event.target as HTMLSelectElement;
    this.selectedTerrain = target.value;
    this.sliderdata();
    this.checkDataAvail()
  }

async  nextStep(data) {
    if (this.currentStep <= 3) {
      this.applicationAMC();
      this.currentStep+=1;
      event.preventDefault();
      if(this.bookingData.lob ==  "HCV Const"){
        if( (this.bookingData.lob == 'HCV Const' && this.bookingData.pl == 'SIGNA 4830.TK.') || (this.bookingData.lob == 'HCV Const' && this.bookingData.pl == 'SIGNA 4830.TK. FBV') || (this.bookingData.lob == 'HCV Const' && this.bookingData.pl == 'SIGNA 4825.TK.')||(this.bookingData.lob == 'HCV Const' && this.bookingData.pl == 'SIGNA 4230.TK.')){
          this.isHCV = false
        } else{
          this.isHCV = true
        }

      }else{
        this.isHCV = false
      }

    }
    if (data == true) {
      try {
        await this.vastatrequestresponse(); // Wait for API response
      } catch (error) {
        console.error("Error in vastatrequestresponse:", error);
      }
    } 
  }

  BookingVas(){
    try {
      this.spinner.show()
      let data = {
        arn: 'None',
        region: '',
        state: this.userData ? this.userData.state : '',
        city: this.userData ? this.userData.city : '',
        vc_number: this.bookingData.vehicle_number,
        lob:  this.bookingData.lob,
        ppl:  this.bookingData.ppl,
        pl:  this.bookingData.pl,
        emission_standard:"BS6 PH-II",
// this.bookingData.emission_norms,
        body_type: this.bookingData?.body_type ? this.bookingData?.body_type : 'None' ,
        fuel_type: this.bookingData.fuel_type,
        payload: this.bookingData.payload,
        number_of_chassis_to_enroll:  this.form.controls['vehicles'].value ? this.form.controls['vehicles'].value : '1',
        vehicle_application: this.form.controls['application'].value.display_application,
        chassis_to_enroll: 'None',
        average_monthly_km: this.bookingData.lob !== 'HCV Const' || (this.bookingData.lob == 'HCV Const' && this.bookingData.pl == 'SIGNA 4830.TK.') || (this.bookingData.lob == 'HCV Const' && this.bookingData.pl == 'SIGNA 4830.TK. FBV') || (this.bookingData.lob == 'HCV Const' && this.bookingData.pl == 'SIGNA 4825.TK.')||(this.bookingData.lob == 'HCV Const' && this.bookingData.pl == 'SIGNA 4230.TK.')
        ? Math.floor(this.form.controls['range1'].value / 12) : '',
    average_monthly_hours: (this.bookingData.lob == 'HCV Const' && this.bookingData.pl == 'SIGNA 4830.TK') || (this.bookingData.lob == 'HCV Const' && this.bookingData.pl == 'SIGNA 4830.TK. FBV') || (this.bookingData.lob == 'HCV Const' && this.bookingData.pl == 'SIGNA 4825.TK')||(this.bookingData.lob == 'HCV Const' && this.bookingData.pl == 'SIGNA 4230.TK') ? "" : this.bookingData.lob == 'HCV Const' ? Math.floor(this.form.controls['range1'].value / 12) : '',
 customer_tml_fleet_size: 'None',
        contract_duration: Math.floor(this.form.controls['range2'].value.toString()/12),
        terrain: this.form.controls['terrain'].value,
        key_account: 'No',
        cust_previous_vas_hist_by_no_of_chassis: 'None',
      };
      this.vas_configurator_request = data;
      this.apiService.AmcWraperData(data)
      .subscribe({
        next: (response: any) => {
          this.vas_configurator_response = response;
          if ((response.success && Object.keys(response.data.vas_recommendation)?.length>0) && (this.bookingData.lob == 'HCV Cargo' || this.bookingData.lob == 'HCV Const'|| this.bookingData.lob == 'LCV' || this.bookingData.lob == 'MCV Trucks' || this.bookingData.lob == 'ICV Trucks')) {
            this.spinner.hide()
              this.amcproductData = [response?.data.vas_recommendation]
              const vasRecommendation = response?.data?.vas_recommendation || {};
            this.amcDataArray = Object.keys(vasRecommendation).map((key) => {
              let extendedData = {
                amcDataArray:this.amcDataArray,
                isHcv:this.isHCV
              }
              if((this.datadismiss == true) && (this.bookingData.lob == 'HCV Const' || this.bookingData.lob == 'HCV Cargo'|| this.bookingData.lob == 'LCV' || this.bookingData.lob == 'MCV Trucks' || this.bookingData.lob == 'ICV Trucks')){
                if(isPlatformBrowser(this.platformId)){

                  localStorage.setItem('extendedVas',JSON.stringify(extendedData))
                }
              }

            return { ...vasRecommendation[key] };
               });
              // this.nextStep()
              this.datadismiss = true
            } else {
              this.datadismiss = false

              // this.goToamc();
            }
            this.spinner.hide()
          },
          error: (err) => {
            this.spinner.hide()
            if (err.name === 'TimeoutError') {
              console.error('Request timed out.');
            } else {
              console.error('API call failed', err);
            }
            this.invalidReq = true;
            this.showLoader=false
          }
        });

      } catch (error) {
        this.showLoader=false
      }
  }

  getPlanImage(value): string {
    let plan = value || ''; // Get the plan or an empty string
    return '../../../assets/images/' + plan?.toLowerCase()
    .replace(/\s+/g, '_')
      .trim()
      +'.png'; // Generate the image path
  }

  numberofVehicleEvent(event: any){
    this.form.controls['terrain'].setValue('');
    this.form.controls['application'].setValue('');
  }

  calculateTotalAmount(data: any): number {
    return data.reduce((sum, service) => {
      const contractYears = service['contract years'] ? service['contract years'] : 1;
      const chasis =  service['number_of_chassis'] ? service['number_of_chassis'] : 1;
      return sum + ((service.price_per_year * contractYears) * chasis);
    }, 0);
  }

  calculateTotalAmountperyear(data:any) {
    return data.reduce((sum, service) => {
       return sum + (service.price_per_year);
     }, 0);
   }
   vastatrequestresponse(data?){
    //   let Payload = {
    //     "id": "",
    //     "home_configurator_request": this.vas_configurator_request ? this.vas_configurator_request : '',
    //     "home_configurator_response": this.vas_configurator_response ? this.vas_configurator_response:'' ,
    //     "osp_configurator_vas_filter_request":this.osp_configurator_request ? this.osp_configurator_request : '',
    //     "osp_configurator_vas_filter_response":this.osp_configurator_response ? this.osp_configurator_response : '',
    //     "request_id": "",
    //     "vehicle_number":this.bookingData.vehicle_number,
    //     "model": this.bookingData.model,
    //     "number_of_vehicles": this.form.controls['vehicles'].value,
    //     "application": this.form.controls['application'].value.actual_application,
    //     "terrain": this.form.controls['terrain'].value,
    //     "annual_runnig": this.form.controls['range1'].value.toString(),
    //     "duration_of_amc":this.form.controls['range2'].value.toString(),
    //     "vas_offer": "",
    //     "amc": "",
    //     "fms": "",
    //     "ew": "",
    //     "oss": "",
    //     "fleetedge": "",
    //     "uptime_guarantee": "",
    //     "source": ""
    //   };
    // this.spinner.show();
    //   try {
    //     this.sub.add(
    //       this.apiService.getvastat(Payload).subscribe({
    //         next: (res: any) => {
    //           if (res?.success) {
    //            this.spinner.hide();
    //            if(res?.data?.id){
    //             localStorage.removeItem('tat_id');
    //             localStorage.setItem('tat_id',res?.data?.id);
    //             }
    //           } else {
    //             this.spinner.hide();
    
    //           }
    //         },
    //         error: (error: any) => {
    //           this.spinner.hide();
    
    //         },
    //         complete: () => {
    //           this.spinner.hide();
    //         }
    //       })
    //     );
    //   } catch (error) {
    //     this.spinner.hide();
    
    //   }
      return new Promise((resolve, reject) => {
        let Payload = {
          "id": "",
          "home_configurator_request": this.vas_configurator_request ? this.vas_configurator_request : '',
          "home_configurator_response": this.vas_configurator_response ? this.vas_configurator_response:'' ,
          "osp_configurator_vas_filter_request":this.osp_configurator_request ? this.osp_configurator_request : '',
          "osp_configurator_vas_filter_response":this.osp_configurator_response ? this.osp_configurator_response : '',
          "request_id": "",
          "vehicle_number":this.bookingData.vehicle_number,
          "model": this.bookingData.model,
          "number_of_vehicles": this.form.controls['vehicles'].value ? Number(this.form.controls['vehicles'].value) : 0,
          "application": this.form.controls['application'].value.actual_application,
          "terrain": this.form.controls['terrain'].value,
          "annual_runnig": this.form.controls['range1'].value.toString(),
          "duration_of_amc":this.form.controls['range2'].value.toString(),
          "vas_offer": "",
          "amc": "",
          "fms": "",
          "ew": "",
          "oss": "",
          "fleetedge": "",
          "uptime_guarantee": "",
          "source": "",
          "vas_booking_price":"",
        };
    
        this.spinner.show();
    
        this.apiService.getvastat(Payload).subscribe({
          next: (res: any) => {
            this.spinner.hide();
            if (res?.success) {
              if(res?.data?.id){
                localStorage.removeItem('tat_id');
                localStorage.setItem('tat_id',res?.data?.id);
                }
              resolve(res);
            } else {
              reject("API call failed.");
            }
          },
          error: (error: any) => {
            this.spinner.hide();
            reject(error);
          },
          complete: () => {
            this.spinner.hide();
          }
        });
      });
    
    }
  vastatrequestresponsereturn(data?): Promise<any> {
    return new Promise((resolve, reject) => {
      let id = localStorage.getItem('tat_id');
      let vasData = this.localStorage.getItem('VASData');
      let parsedData = vasData ? JSON.parse(vasData) : {}; 
      console.log(parsedData);
      let vasOffer = "";
  let vasBookingPrice = "";
  
  if (Array.isArray(parsedData?.VASPLAN) && parsedData.VASPLAN.length > 0) {
      vasOffer = parsedData.VASPLAN[0].plan || "";
      vasBookingPrice = parsedData.VASPLAN[0].price_per_year ? `${(Math.round(parsedData.VASPLAN[0].price_per_year) * (parsedData.VASPLAN[0]['contract years'] || 1)) * (parsedData.VASPLAN[0].number_of_chassis || 1)}` : "";
  }
      let Payload = {
        "id": id ? id:'',
        "home_configurator_request": this.vas_configurator_request || '',
        "home_configurator_response": this.vas_configurator_response || '',
        "osp_configurator_vas_filter_request": this.osp_configurator_request || '',
        "osp_configurator_vas_filter_response": this.osp_configurator_response || '',
        "request_id": "",
        "vehicle_number": this.bookingData.vehicle_number ? this.bookingData.vehicle_number : '',
        "model": this.bookingData.model ? this.bookingData.model : '',
        "number_of_vehicles": this.form.controls['vehicles'].value ? Number(this.form.controls['vehicles'].value) : 0,
        "application": this.form.controls['application'].value.actual_application,
        "terrain": this.form.controls['terrain'].value,
        "annual_runnig": this.form.controls['range1'].value.toString(),
        "duration_of_amc": this.form.controls['range2'].value.toString(),
        "vas_offer": vasOffer ? vasOffer : '',
        "amc": "",
        "fms": "",
        "ew": this.getPlanPrice('Extended Warranty'), 
        "oss": "",
        "fleetedge": this.getPlanPrice('ADVANCE FLEETEDGE'), 
        "uptime_guarantee": this.getPlanPrice('Uptime Guarantee'),  
        "source": "",
        "vas_booking_price":vasBookingPrice ? vasBookingPrice :'',
      };
  
      this.spinner.show();
  
      this.apiService.getvastat(Payload).subscribe({
        next: (res: any) => {
          this.spinner.hide();
          if (res?.success) {
            
            resolve(res);
          } else {
            reject("API call failed.");
          }
        },
        error: (error: any) => {
          this.spinner.hide();
          reject(error);
        },
        complete: () => {
          this.spinner.hide();
        }
      });
    });
  }
  getPlanPrice(planName: string): string {
    let vasData = this.localStorage.getItem('VASData');
    let parsedData = vasData ? JSON.parse(vasData) : {};
  
    // Ensure VASPLAN exists and has at least two elements (ignoring 0th position)
    if (!Array.isArray(parsedData?.VASPLAN) || parsedData.VASPLAN.length === 0) {
        return "";
    }
  
    // Find the matching plan but skip the first element (VASPLAN[0])
    const plan = parsedData.VASPLAN.slice(1).find(item => item.plan?.toUpperCase() === planName.toUpperCase());
  
    if (plan && Number.isFinite(plan.price_per_year) && Number.isFinite(plan["contract years"])) {
      return `${(Math.round(plan.price_per_year * plan["contract years"])* plan.number_of_chassis)}`;
    }
  
    return "";
  }
  loadScript(): void {  
    if (isPlatformBrowser(this.platformId)) {
    if (this.isChatbotLoaded) {
      if (window['toggleChatbox']) {
        window['toggleChatbox']();
      } else {
        console.error('toggleChatbox function is not defined.');
      }
      return;
    }
  
    const script = this.renderer.createElement('script');
    script.src = 'assets/finalchatbot_osp/newChatbot.js';
  
    script.onload = () => {
      console.log("Chatbot script loaded successfully.");
  
      if (window['initializeChatbot']) {
        const sessionId = localStorage.getItem('sessionId') || 'defaultSession';
        window['initializeChatbot'](sessionId);
        
        this.isChatbotLoaded = true;
        if (window['toggleChatbox']) {
          window['toggleChatbox']();
        } else {
          console.error('toggleChatbox function is not defined.');
        }
      } else {
        console.error('initializeChatbot function is not defined.');
      }
    };
  
    script.onerror = () => {
      console.error('Error loading chatbot script.');
    };
  
    this.renderer.appendChild(document.body, script);
   }
  }
    ngOnDestroy() {
    if (isPlatformBrowser(this.platformId)) {
      // localStorage.removeItem('sideFilter')
      localStorage.removeItem("normalFilterValue");
      this.sub.unsubscribe();
    }
  }
  @HostListener('window:resize', ['$event'])
  onResize() {
    // Manually trigger change detection or logic to refresh the image if needed
    this.cdRef.detectChanges();
  }
 
  updateImageSize(imageUrl: string, element: HTMLElement, width?: number, height?: number): string {
    if (!isPlatformBrowser(this.platformId)) {
      return imageUrl;
    }
 
    if (!imageUrl) {
      console.log('Invalid image URL');
      return '';
    }
 
    if (!element) {
      console.log('Invalid Element');
      return imageUrl;
    }
 
    // Get actual width & height of the card
    const actualWidth = width && width > 0 ? width : element.clientWidth;
    const actualHeight = height && height > 0 ? height : element.clientHeight;
 
    const imgWidth = Math.floor(actualWidth * 0.8);
    const imgHeight = Math.floor((imgWidth / 100) * 67);
 
    const cleanedUrl = imageUrl.replace(/\/resize\/\d+x\d+$/, '');
    const updatedUrl = `${cleanedUrl}/resize/${imgWidth}x${imgHeight}`;
 
    return updatedUrl;
  }
}
